import { FC, useEffect } from 'react';
import { useLazyLoadQuery } from 'react-relay';
import { DiagnosticsGetStudentsTableQuery } from '../../../../graphQLOperations/__generated__/DiagnosticsGetStudentsTableQuery.graphql';
import { getStudentsDiganosticReportTableInfo } from '../../../../graphQLOperations/Diagnostics';

export const DiagnosticsStudentsFetcher: FC<{
  classId: string;
  roadmapId: string;
  onData: (items: NonNullable<DiagnosticsGetStudentsTableQuery['response']['classDiagnosticReport']>) => void;
  onDone: () => void;
}> = ({ classId, roadmapId, onData, onDone }) => {
  const data = useLazyLoadQuery<DiagnosticsGetStudentsTableQuery>(
    getStudentsDiganosticReportTableInfo,
    { input: { classIds: [classId], roadmapId } },
    { fetchPolicy: 'network-only', fetchKey: `STUDCSV:${classId}:${roadmapId}` },
  );

  useEffect(() => {
    onData(data?.classDiagnosticReport ?? []);
    onDone();
  }, [data, onData, onDone]);

  return null;
};
